export default "__VITE_ASSET__I$qiYpOL__"